import { useState } from 'react';

export const useCallsScreen = () => {
  const [selectedKey, setSelectedKey] = useState('Incoming');
  const [showIncoming, setShowIncoming] = useState(true);

  const updateData = (key: string) => {
    switch (key) {
      case 'Incoming':
        setSelectedKey('Incoming');
        setShowIncoming(true);
        break;
      case 'Outgoing':
        setSelectedKey('Outgoing');
        setShowIncoming(false);
        break;
    }
  };

  return {
    selectedKey,
    updateData,
    showIncoming,
  };
};
